import Customer from './Customer';

export default Customer;
